import { render, staticRenderFns } from "./trustedDataTrading.vue?vue&type=template&id=068ddaa7&scoped=true&"
import script from "./trustedDataTrading.vue?vue&type=script&lang=js&"
export * from "./trustedDataTrading.vue?vue&type=script&lang=js&"
import style0 from "./trustedDataTrading.vue?vue&type=style&index=0&id=068ddaa7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ddaa7",
  null
  
)

export default component.exports